// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "8627a13e" + "." + "da7857e13bcd5285" + ".js";
};